(ns hai.ui.components.form.select.common
  (:require
   [lambdaisland.ornament :refer [defstyled]]))

;;;
;;; Options
;;;

;; TODO these styles are not isolated from browser extension, they are visually broken when not used
;; withing the extension
(defstyled options-styled :div
  :absolute
  {:background-color "white"
   :top "100%"
   :margin-top "2px"
   :max-height "480px"
   :overflow-y "auto"
   :width "100%"
   :z-index "100"})

;; TODO these styles are not isolated from browser extension, they are visually broken when not used
;; withing the extension
(defstyled option-styled :div
  :cursor-pointer
  :border
  :border-gray-200
  {:border-bottom {:width "0"}
   :border-top {:width "0"}}
  [:>div
   :py-2
   :px-4
   ;; keeps the space needed for the border so that the text does not jump
   ;; around; the issue is that the border on non-hovered elements is
   ;; 1px but the border on the hovered elements is 2px
   {:border-left {:width "1px"
                  :color "transparent"
                  :style "solid"}
    :display "flex"
    :align-items "center"
    :gap "7px"
    :justify-content "start"}]
  [:&:first-child
   {:border-top {:width "1px"}
    :border-top-left-radius "4px"
    :border-top-right-radius "4px"}]
  [:&:last-child
   {:border-bottom-left-radius "4px"
    :border-bottom-right-radius "4px"
    :border-bottom {:width "1px"}}]
  [:&.active {:background-color "#F1F9FF"
              :border-left-color "#3563FA"}])

